import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, COLLECTION } from '@/plugins/sdk/fields'
import CarrierDepot from '@/plugins/sdk/resources/Pivot/Depot'

export default class extends Resource {
  static name = 'depot'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      services: new STRING(),
      service_area: new STRING(),
      full_address: new STRING(),
      house_account: new STRING(),
      pickup_cutoff: new STRING(),
      main_phone: new STRING(),
      pickup_phone: new STRING(),
      tracking_link: new STRING(),
      www_login: new STRING(),
      www_pass: new STRING(),
      chep_acct: new STRING(),
      loscam_acct: new STRING(),
      other_info: new STRING(),
      carrier_mgr: new STRING(),
      file_mgr: new STRING(),
      deleted: new STRING(),
      deleted_date: new DATETIME(),
      carrier_depot: new COLLECTION(CarrierDepot)
    }
  }
}
